import { render } from "./ToggleStar.vue?vue&type=template&id=28c1e10d&scoped=true"
import script from "./ToggleStar.vue?vue&type=script&lang=js"
export * from "./ToggleStar.vue?vue&type=script&lang=js"

import "./ToggleStar.vue?vue&type=style&index=0&id=28c1e10d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28c1e10d"

export default script